import { Card } from "antd";
import { Projects } from "@modules";
import { Breadcrumb } from "@components";
import { useParams } from "react-router-dom";

export default function ProjectPage() {
  const { id } = useParams();

  return (
    <div className="container max-content">
      <Breadcrumb
        data={[
          { title: "Projects", href: "/projects" },
          { title: "Details", href: `/projects/view/${id}` },
        ]}
      />
      <h1 className="mb-8 text-3xl">Project Details</h1>
      <div className="grid grid-cols-12 gap-4">
        <div className="col-span-12">
          <Card bordered={false}>
            <Projects.View projectId={id} />
          </Card>
        </div>
      </div>
    </div>
  );
}
